import { render, staticRenderFns } from "./SubscriptionBanner.vue?vue&type=template&id=639139b8&scoped=true"
import script from "./SubscriptionBanner.vue?vue&type=script&lang=js"
export * from "./SubscriptionBanner.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionBanner.vue?vue&type=style&index=0&id=639139b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639139b8",
  null
  
)

export default component.exports